import Vue from "vue";
import PortalVue from "portal-vue";
import EventManager from "vue-simple-events/cjs";

import App from "./App.vue";
import { VueMetrika } from "./classes/metrika";
import SvgUse from "./components/SvgUse.vue";
import store from "./store";

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(PortalVue);
Vue.use(EventManager);
Vue.use(VueMetrika);
Vue.component("svg-use", SvgUse);

new Vue({ render: h => h(App), store }).$mount("#app");
